export enum EventStatus {
  APPROVED = 'APPROVED',
  REJECTED_OR_DELETED = 'REJECTED_OR_DELETED',
  WAITING_FOR_APPROVAL = 'WAITING_FOR_APPROVAL',
}
